import { PROPERTY_COLORS } from '@/features/property/utils/consts';
import React from 'react';

// Color map for legend and markers - updated to use shared colors
const typeColorMap = {
  ownProperty: PROPERTY_COLORS.ownProperty.bg,
  competitor: PROPERTY_COLORS.competitor.bg,
  market: PROPERTY_COLORS.market.bg
};

export const MapLegend: React.FC = () => (
  <div className="flex items-center gap-4 p-2 text-sm font-medium bg-white rounded-md shadow-lg">
    <LegendItem color={typeColorMap.ownProperty} label="Your Property" />
    <LegendItem color={typeColorMap.competitor} label="Competitors" />
    <LegendItem color={typeColorMap.market} label="Market Properties" />
  </div>
);

const LegendItem: React.FC<{ color: string; label: string }> = ({ color, label }) => (
  <div className="flex items-center gap-2">
    <div className={`${color} w-4 h-4 rounded-full flex-shrink-0`} aria-hidden="true"></div>
    <span className="inline-block leading-none" style={{ transform: 'translateY(0.5px)' }}>{label}</span>
  </div>
);

export const MapLegendControl: React.FC = () => {
  const positionClass = 'leaflet-top leaflet-right';

  return (
    <div className={positionClass}>
      <div className="leaflet-control m-3">
        <MapLegend />
      </div>
    </div>
  );
};

export default MapLegendControl;